<template>
  <div class="connect-page">
    <div class="container" :class="{ operator: showOperatorLogin }">
      <div v-if="connectionStatus.type === 'ready'">
        <div
          class="operator-access"
          @click="showOperatorLogin = !showOperatorLogin"
        >
          <img src="../assets/images/icon-operator.png" />
          <span class="rollover">
            <b>[&nbsp;</b>
            <i v-if="!showOperatorLogin">login as operator</i>
            <i v-else>login as participant</i>
            <b>&nbsp;]</b>
          </span>
        </div>

        <div class="form" v-show="!showOperatorLogin">
          <input
            type="text"
            name="name"
            placeholder="[ FULL NAME ]"
            v-model="userName"
            autofocus
          />
          <input
            type="password"
            name="passcode"
            placeholder="[ PASSCODE ]"
            v-model="passcode"
          />
          <button type="submit" @click="signInAsParticipant">ENTER</button>
        </div>

        <div class="form" v-show="showOperatorLogin">
          <input type="text" value="[ OPERATOR ]" name="name" disabled />
          <input
            type="password"
            name="passcode"
            placeholder="[ PASSCODE ]"
            v-model="passcode"
            autofocus
          />
          <button type="submit" @click="signInAsOperator">ENTER</button>
        </div>
      </div>

      <p v-else-if="connectionStatus.type === 'connecting'" class="status">
        {{ connectionStatus.message }}
      </p>

      <p v-else-if="connectionStatus.type === 'error'" class="status">
        {{ connectionStatus.message }}
      </p>

      <div v-else-if="connectionStatus.type === 'success'" class="waiting">
        <clock class="clock" fontSize="80px"></clock>
        <p class="status">Awaiting participants...</p>
      </div>

      <hint-page
        v-show="showControllerHint"
        class="controllerHint"
        @close="$store.commit('SET_CONTROLLER_HINT', false)"
      >
        <p>
          <i>
            Welcome, you are the “Controller”.
            <br />
            <br />You can pass control at any time by clicking this icon.
          </i>
        </p>
        <img src="../assets/images/icon-participant.png" class="icon-preview" />
      </hint-page>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Clock from "../components/Clock.vue";
import HintPage from "./HintPage";

export default {
  components: {
    Clock,
    HintPage,
  },
  data: function () {
    return {
      userName: "",
      passcode: "",
      showHint: false,
      showOperatorLogin: false,
    };
  },
  computed: {
    ...mapState(["connectionStatus", "user", "session", "showControllerHint"]),
  },
  methods: {
    signInAsParticipant() {
      // Check if session is locked for participants
      if (this.session.isLocked) {
        alert("The session is no longer available");
        return;
      }
      // Check the user has entered their name
      else if (this.userName == "") {
        alert("You must write your name before joining");
        return;
      }

      // Check the user has entered a passcode
      else if (this.passcode == "") {
        alert("Please enter the session passcode");
        return;
      }

      // Check the passcode is valid
      else if (this.passcode != this.session.passcode) {
        alert("The passcode is incorrect, please check and try again");
        return;
      }

      // Finally log in
      else {
        // init the audio ('after user interaction);
        this.$store.dispatch("initHowler");

        // Play a silent track from click to enable video & sound in the future (iOS requires user interaction)
        this.$store.dispatch("playHowler", "silence");

        // First sign in anonymously
        this.$store
          .dispatch("signInAnonymously", { name: this.userName })
          .then(() => {
            // Then connect to firebase to start syncing
            this.$store.dispatch("connectToFirebase");
          })
          .catch((error) => {
            console.error("signInAnonymously ERROR: ", error);
          });
      }
    },

    signInAsOperator() {
      // Check the user has entered a passcode
      if (this.passcode == "") {
        alert("Please enter the operator passcode");
        return;
      }

      // Check the passcode is valid
      else if (this.passcode != this.session.operatorCode) {
        alert("The passcode is incorrect, please check and try again");
        return;
      }

      // Finally log in
      else {
        // init the audio ('after user interaction);
        this.$store.dispatch("initHowler");

        // Play a silent track from click to enable video & sound in the future (iOS requires user interaction)
        this.$store.dispatch("playHowler", "silence");

        // First sign in anonymously
        this.$store
          .dispatch("signInAnonymously", { name: "operator", isAdmin: true })
          .then(() => {
            // Then connect to firebase to start syncing
            this.$store.dispatch("connectToFirebase");
          })
          .catch((error) => {
            console.error("signInAnonymously ERROR: ", error);
          });
      }
    },
  },
};
</script>

<style lang="scss">
.connect-page {
  position: absolute;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: #f1ece6;
  display: flex;
  justify-content: center;
  align-items: center;

  .container {
    position: relative;
    width: 768px;
    height: 768px;
    background-image: url("../assets/images/page-timer.png");

    &.operator {
      .form {
        input {
          border-color: white;
          background-color: black;
          color: white;
          &::placeholder,
          &:disabled {
            color: white;
          }
        }
      }
      .operator-access img {
        object-position: 100% 0;
      }
    }

    .form {
      position: relative;

      input {
        outline: none;
        background: none;
        border: none;
        border-bottom: 1px solid black;
        color: inherit;
        width: 205px;
        height: 30px;
        padding: 4px 0 0 6px;

        &::placeholder,
        &:disabled {
          color: inherit;
          opacity: 1;
        }
      }
      input[name="name"] {
        position: absolute;
        left: 120px;
        top: 620px;
        text-transform: uppercase;
      }
      input[name="passcode"] {
        position: absolute;
        left: 355px;
        top: 620px;
      }
      button {
        position: absolute;
        left: 590px;
        top: 620px;
        width: 60px;
        height: 30px;
        background-color: black;
        color: #f1ece6;
        border: none;
        outline: none;
        text-transform: uppercase;
        font-size: 14px;
        line-height: 32px;
        cursor: pointer;
      }
    }

    .waiting {
      width: 768px;
      height: 768px;
      position: relative;

      .clock {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60%;
        height: 100%;
        margin-left: auto;
        margin-right: auto;
      }
    }

    .status {
      position: absolute;
      left: 120px;
      top: 628px;
    }

    .operator-access {
      position: fixed;
      top: 35px;
      left: 35px;
      cursor: pointer;

      img {
        width: 35px;
        height: 35px;
        object-fit: cover;
        object-position: 0 0;
      }

      .rollover {
        display: none;
        position: absolute;
        top: 10px;
        left: 40px;
        width: 300px;
        // text-align: right;
      }

      &:hover {
        .rollover {
          display: block;
        }
      }
    }
  }
}
</style>
